import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {moduleConfig} from "../config";
import {ApplicationProductRecordFormProps} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<ApplicationProductRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${moduleConfig.titles.singular}`
        : `New ${moduleConfig.titles.singular}`

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={(values) => {
                    handleSubmit(values)
                    onClose();
                }}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
